
import axios from 'axios'
import Vue from 'vue'
const BACKEND_URL = process.env.BACKEND_URL+"tickets/"
const STATS_URL = process.env.BACKEND_URL+"static/"
const STAFF_URL = process.env.BACKEND_URL+"staff/"

const tickets = new Vue ({
  beforeCreate(){
    axios.defaults.withCredentials = true;
  },
    methods : {
      getTickets(index){
        const url = `${BACKEND_URL}?index=${index}`
        return axios.get(url).then(response => response.data)
      },
      getTicketsStaff(index,guild_id){
        const url = `${STAFF_URL}${guild_id}/tickets?index=${index}`
        return axios.get(url).then(response => response.data)
      },
      getStats(){
        const url = `${STATS_URL}stats`
        return axios.get(url).then(response => response.data)
      },
      searchStaff(id,query,index){
        const url = `${STAFF_URL}${id}/search?query=${query}&index=${index}`
        return axios.get(url).then(response => response.data)
      },
      search(query,index){
        const url = `${BACKEND_URL}/search?index=${index}&query=${query}`
        return axios.get(url).then(response => response.data)
      },
      advancedSearch(searchObj, index){
        let initialUrl = `${BACKEND_URL}asearch?index=${index}`
        const url = buildSearchUrl(initialUrl,searchObj)
        return axios.get(url).then(response => response.data)
      },
      advancedSearchStaff(searchObj,guild_id,index){
        let initialUrl = `${STAFF_URL}${guild_id}/search/asearch?index=${index}`
        const url = buildSearchUrl(initialUrl,searchObj)
        return axios.get(url).then(response => response.data)
      }
    },
  })
  
function buildSearchUrl(initialUrl,searchObj){
  for(let prop in searchObj){
    const val = searchObj[prop]
    if(val != undefined && val != ""){
    initialUrl+=`&${prop}=${searchObj[prop]}`
    }
  }
  return initialUrl
}
  
  export default {
    install: function(Vue) {
      Vue.prototype.$tickets= tickets
    }
  }


// WEBPACK FOOTER //
// ./src/api/tickets.js